import React, { useState } from 'react'
import { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { ChargeAmpsLandingPageLogo } from '../../../lib/charge-amps-landing-page-logo'
import Text from '../../../ui/Text'
import { UserAgreement } from '../../components/user-agreement'
import { useUserAcceptTermsMutation } from '../../../common/redux/api/web-api'
import useText from '../../../common/hooks/useText'
import { setUser } from '../../../common/redux/features/user/userSlice'
import { useSessionUser } from '../../../common/hooks/useSessionUser'

const SColumn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const STitle = styled.div`
    color: #000000;
    letter-spacing: 1%;
    font-size: 30px;
`
const SChargeAmpsLandingPageLogo = styled(ChargeAmpsLandingPageLogo)<{ dark?: boolean }>`
    fill: ${({ theme, dark }) => (dark ? theme.font.lightestColor : theme.font.darkestColor)};
`
export type UserAgreementPageProps = {
    children: React.ReactNode
    className?: ClassName
    style?: React.CSSProperties
}

export function UserAgreementPage(): React.ReactElement {
    const text = useText()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const user = useSessionUser()
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [acceptTerms] = useUserAcceptTermsMutation()

    const cancel = () => {
        navigate('/login', { replace: true })
    }

    const handleAcceptTerms = () => {
        acceptTerms()
            .unwrap()
            .then(() => {
                const updatedUser = { ...user, personalAccept: new Date().toDateString() }
                dispatch(setUser(updatedUser))
                navigate('/dashboard', { replace: true })
            })
            .catch(() => setErrorMessage(text('msgErrorAcceptingTerms')))
    }

    return (
        <div>
            <div className="logo" data-testid="logo">
                <SChargeAmpsLandingPageLogo />
            </div>
            <div className="page-layout-container" data-testid="container">
                <div className="row">
                    <SColumn className="row text-center heading" data-testid="tite-container">
                        <STitle className="row" data-testid="title">
                            <Text code="lblTermsOfServicePage" />
                        </STitle>
                    </SColumn>
                    <UserAgreement
                        cancel={cancel}
                        accept={handleAcceptTerms}
                        errorMessage={errorMessage}
                    ></UserAgreement>
                </div>
            </div>
        </div>
    )
}
